/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Manager_Edit_Form_TitleInputs */



/**
* | output |
* | --- |
* | "Tag Edit Form" |
*
* @param {Tags_Manager_Edit_Form_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_manager_edit_form_title = /** @type {((inputs?: Tags_Manager_Edit_Form_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Manager_Edit_Form_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Formulaire d'edition des tags")
	if (locale === "de") return /** @type {LocalizedString} */ ("Tag-Bearbeitungsformular")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modulo di modifica tag")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Форма редактирования тега")
	if (locale === "es") return /** @type {LocalizedString} */ ("Formulario de edición de etiquetas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("标签编辑表单")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タグ編集フォーム")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टैग संपादन फ़ॉर्म")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Formulário de edição de tags")
	return /** @type {LocalizedString} */ ("Tag Edit Form")
});